import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const ExactVATCodeRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings--exact-vat-code']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
